import { noticeAdd, noticeModalOpen } from '../actions/noticeActions';

const noticeMiddleware = ({ dispatch, getState }) => next => action => {
  next(action);

  switch(action.type){
    case 'AUTH_FORM_SUBMIT_START':
    case 'RECORDS_FETCHING_START':
    case 'LOGIN_START':
      dispatch(noticeAdd({
        text: action.payload,
        type: 'loading'
      }));
      break;
    case 'LOGIN_ERROR':
      dispatch(noticeAdd({
        title: 'Ошибка',
        text: action.payload,
        type: 'error'
      }));
      break;    
    case 'AUTH_FORM_SUBMIT_ERROR':
      dispatch(noticeAdd({
        title: 'Ошибка',
        text: action.payload,
        type: 'error'
      }));
      break;
    case 'AUTH_FORM_SUBMIT_SUCCESS': 
      dispatch(noticeAdd({
        title: 'Info',
        text: `Ссылка для авторизации, будет приходить на email, если он есть в базе и будет недействительна сразу после перехода по ней. Пока просто скопируйте адрес и вставьте в адресную строку http://service.videomax-server.ru`+action.payload,
        type: 'info'
      }));
      break;
    case 'RECORD_EDIT_FORM_SUBMIT_SUCCESS':
      dispatch(noticeAdd({
        title: 'Ok!',
        text: 'Запись успешно обновлена',
        type: 'success'
      }));
      break;
    case 'RECORD_EDIT_FORM_SUBMIT_ERROR':
      dispatch(noticeAdd({
        title: 'Ошибка',
        text: action.payload,
        type: 'error'
      }));
      break;
    case 'RECORD_DELETE_FORM_SUBMIT_SUCCESS':
      dispatch(noticeAdd({
        title: 'Ok!',
        text: 'Запись успешно удалена',
        type: 'success'
      }));
      break;
    case 'RECORD_DELETE_FORM_SUBMIT_ERROR':
      dispatch(noticeAdd({
        title: 'Ошибка',
        text: action.payload,
        type: 'error'
      }));
      break;
    case 'RECORD_ADD_FORM_SUBMIT_SUCCESS':
      dispatch(noticeAdd({
        title: 'Ключ активации сгенерирован и добавлен в базу',
        text: action.payload.key,
        type: 'success_modal'
      }));
      break;
    case 'RECORD_ADD_FORM_SUBMIT_ERROR':
      dispatch(noticeAdd({
        title: 'Ошибка',
        text:  action.payload,
        type: 'error'
      }));
      break;
    case 'RECORDS_FETCHING_NO_RESULT':
      dispatch(noticeAdd({
        title: 'Внимание!',
        text: 'К сожалению, ничего не найдено',
        type: 'warning'
      }));
      break;
    case 'RECORDS_FETCHING_ERROR':
      dispatch(noticeAdd({
        title: 'Ошибка',
        text: action.payload,
        type: 'error'
      }));
      break;
    case 'RECORD_KEY_COPY_TO_CLIPBOARD_SUCCESS':
      dispatch(noticeAdd({
        text: `Ключ ${action.payload.key} скопирован в буфер`,
        type: 'success_modal'
      }));
      break;

  }

}

export default noticeMiddleware;


// WEBPACK FOOTER //
// ./src/middlewares/noticeMiddleware.js